<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    v-layout(column)
      v-flex.mb-3
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") autorenew
            v-flex
              .headline Ad Manager
              .overline Google Ads

      v-flex(fill-height)
        v-card
          v-data-table(
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="15"
            @click:row="onItemClick"
          )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      headers: [
        { text: 'ID', value: 'customer.id' },
        { text: 'Customer', value: 'customer.descriptiveName' },
        { text: 'Currency', value: 'customer.currencyCode' }
      ]
    }
  },
  mounted () {
    if (this.items.length === 0) {
      this.loadCustomers()
    }
  },
  computed: {
    ...mapGetters({
      items: 'ads/customers'
    }),
    loading () {
      return (this.items || []).length === 0
    }
  },
  methods: {
    ...mapActions({
      loadCustomers: 'ads/loadCustomers'
    }),
    onItemClick (item) {
      const id = item.customer.id
      this.$store.dispatch('ads/setCurrentCustomer', item.customer)
      this.$router.push({ name: 'google-ads-campaign', params: { customer: id } })
    }
  }
}
</script>
